import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import './NotFound.css';

class NotFound extends React.Component {

  render() {
    return (
      <div className={classnames('NotFound', this.props.className)}>
        <div className="NotFound__content">
          <h1 className="NotFound__title">
            <FormattedMessage id="NotFound.title"/>
          </h1>
          <div className="NotFound__description">
            <FormattedMessage id="NotFound.description"/>
          </div>
          <Link
            className="NotFound__actionLink"
            to="/">
            <FormattedMessage id="NotFound.action"/>
          </Link>
        </div>
      </div>
    );
  }

}

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/NotFound.js